<ng-container *ngIf="!selectedAbnAcnRecord">
  <mat-form-field class="search-input" [formGroup]="formGroup" appearance="outline">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput placeholder="{{placeholderText}}" [formControl]="formControl" (keyup.enter)="searchAbnAcn()" (change)="checkSearch()">
    <button [disabled]="formControl.errors?.pattern" color="primary" *ngIf="!loadingResults && formControl.enabled" mat-icon-button matSuffix (click)="searchAbnAcn()">
      <mat-icon>search</mat-icon>
    </button>
    <mat-spinner matSuffix class="me-2" [diameter]="20" [strokeWidth]="3" *ngIf="loadingResults"></mat-spinner>
    <mat-error *ngIf="formGroup.get(controlName)?.errors">
      <span *ngIf="formGroup.get(controlName)?.errors['min-length'] || formGroup.get(controlName)?.errors['max-length'] || formGroup.get(controlName)?.errors['not-a-number'] || formControl?.errors?.pattern">Invalid format</span>
      <span *ngIf="formControl.errors?.incorrect && !hasSearched && !formGroup.get(controlName)?.errors['not-a-number'] && !formControl.errors?.pattern">
        Please use the search button to get a valid number.
      </span>
    </mat-error>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="selectedAbnAcnRecord">
  <mat-form-field class="search-input" [formGroup]="formGroup" *ngIf="mode === 'abn'" appearance="outline">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput placeholder="{{placeholderText}}" [formControl]="formControl" [value]="selectedAbnAcnRecord['australian-business-number']?._text">
    <button color="primary" *ngIf="!loadingResults && formControl.enabled" mat-icon-button matSuffix (click)="clearSearch()">
      <mat-icon>highlight_off</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field class="search-input" [formGroup]="formGroup" *ngIf="mode !== 'abn'" appearance="outline">
    <mat-label>{{placeholderText}}</mat-label>
    <input matInput placeholder="{{placeholderText}}" [formControl]="formControl" [value]="selectedAbnAcnRecord['australian-company-number']">
    <button color="primary" *ngIf="!loadingResults && formControl.enabled" mat-icon-button matSuffix (click)="clearSearch()">
      <mat-icon>highlight_off</mat-icon>
    </button>
  </mat-form-field>
</ng-container>
